export default __webpack_public_path__ + "static/media/rock2.9be4d551.jpg";